import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { useExperiment } from '@/libraries/experiment';

const ppExpMap = {
	ft: 'PP_FREETRIAL_EXP_2',
	qtv: 'PP_QTV_EXP',
	sqtv: 'PP_SQTV_EXP',
} as const;

export function usePPExperiments(placement: 'ft' | 'qtv' | 'sqtv') {
	const { activeVariantWithControlGroup } = useExperiment(ppExpMap[placement], 'global');
	const { country } = useLanguageStore();

	function setPPExperimentTags(url: ClickoutUrl, qtvType?: 'pos' | 'cta') {
		if (!activeVariantWithControlGroup.value) return url;
		const suffix = country.value === 'US' ? '20' : '21';

		let variantShort =
			activeVariantWithControlGroup.value === 'control'
				? 'ct'
				: activeVariantWithControlGroup.value.replace('variant_', 'v');

		const placementDetail = qtvType && placement ? `-${qtvType}` : '';

		// Add "-2" to PP_FREETRIAL_EXP_2 tags for 2nd run
		if (placement === 'ft') variantShort = `${variantShort}-2`;

		const tag = `pp-${country.value.toLowerCase()}-${placement}${placementDetail}-${variantShort}-${suffix}`;

		return url.setOnOffer('tag', tag).skipUCT2().skipYieldOptimization();
	}

	return {
		setPPExperimentTags,
	};
}
